import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3378dad0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bottle-container rounded-2" }
const _hoisted_2 = { class: "d-flex align-items-center flex-column" }
const _hoisted_3 = { class: "d-flex gap-2" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "options-container-title" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "fw-normal" }
const _hoisted_8 = { class: "options-container-title" }
const _hoisted_9 = { class: "options-container-message" }
const _hoisted_10 = { class: "fw-normal" }
const _hoisted_11 = { class: "options-container-title" }
const _hoisted_12 = { class: "options-container-message" }
const _hoisted_13 = { class: "fw-normal" }
const _hoisted_14 = { class: "options-container-title" }
const _hoisted_15 = { class: "options-container-message" }
const _hoisted_16 = {
  key: 0,
  class: "fw-normal"
}
const _hoisted_17 = { class: "options-container-title" }
const _hoisted_18 = { class: "options-container-message" }
const _hoisted_19 = { class: "d-flex align-items-center mt-1" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "d-flex gap-3" }
const _hoisted_22 = { class: "fw-normal" }
const _hoisted_23 = { class: "fw-bold" }
const _hoisted_24 = { class: "fw-normal" }
const _hoisted_25 = { class: "fw-bold" }
const _hoisted_26 = { class: "fw-normal" }
const _hoisted_27 = { class: "fw-bold" }
const _hoisted_28 = {
  key: 0,
  class: "fw-normal"
}
const _hoisted_29 = { class: "fw-bold" }
const _hoisted_30 = {
  key: 1,
  class: "asahi-progress-bar-message-no-bg d-flex gap-1 align-items-start w-100 fw-medium"
}
const _hoisted_31 = { class: "d-flex align-items-center marg-16" }
const _hoisted_32 = { class: "gap-3 w-100" }
const _hoisted_33 = { class: "row py-1 bg-white px-1 rounded" }
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = { class: "row py-1" }
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = { class: "row py-1" }
const _hoisted_38 = { class: "col-12 d-flex justify-content-between" }
const _hoisted_39 = { class: "fw-bold" }
const _hoisted_40 = { class: "row py-1" }
const _hoisted_41 = { class: "col-12 d-flex justify-content-between" }
const _hoisted_42 = { class: "fw-bold" }
const _hoisted_43 = { class: "row py-1" }
const _hoisted_44 = { class: "col-12 d-flex justify-content-between" }
const _hoisted_45 = { class: "fw-bold" }
const _hoisted_46 = {
  key: 0,
  class: "row py-1"
}
const _hoisted_47 = { class: "fw-bold" }
const _hoisted_48 = {
  key: 1,
  class: "asahi-progress-bar"
}
const _hoisted_49 = { class: "w-100 rounded-2" }
const _hoisted_50 = { class: "d-flex align-items-center flex-column" }
const _hoisted_51 = { class: "d-flex gap-2 align-items-center" }
const _hoisted_52 = ["innerHTML"]
const _hoisted_53 = { class: "d-flex align-items-center mt-1" }
const _hoisted_54 = ["innerHTML"]
const _hoisted_55 = { class: "d-flex gap-3" }
const _hoisted_56 = { class: "fw-normal" }
const _hoisted_57 = { class: "fw-bold" }
const _hoisted_58 = { class: "fw-normal" }
const _hoisted_59 = { class: "fw-bold" }
const _hoisted_60 = { class: "fw-normal" }
const _hoisted_61 = { class: "fw-bold" }
const _hoisted_62 = {
  key: 0,
  class: "fw-normal"
}
const _hoisted_63 = { class: "fw-bold" }
const _hoisted_64 = { class: "d-flex align-items-start gap-1" }
const _hoisted_65 = ["innerHTML"]
const _hoisted_66 = ["innerHTML"]
const _hoisted_67 = { class: "asahi-compact-message" }
const _hoisted_68 = { class: "d-flex flex-column gap-3 mt-2" }
const _hoisted_69 = {
  key: 0,
  class: "d-flex justify-content-between"
}
const _hoisted_70 = { class: "fw-bold" }
const _hoisted_71 = { class: "d-flex justify-content-between" }
const _hoisted_72 = { class: "fw-bold" }
const _hoisted_73 = { class: "d-flex justify-content-between" }
const _hoisted_74 = { class: "fw-bold" }
const _hoisted_75 = {
  key: 1,
  class: "d-flex justify-content-between"
}
const _hoisted_76 = { class: "fw-bold" }
const _hoisted_77 = { key: 3 }
const _hoisted_78 = { class: "asahi-mini-container" }
const _hoisted_79 = { class: "d-flex align-items-start gap-1" }
const _hoisted_80 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AllertCart = _resolveComponent("AllertCart")!
  const _component_SuccessCart = _resolveComponent("SuccessCart")!
  const _component_AsahiProgress = _resolveComponent("AsahiProgress")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.messageType != 'mini' && _ctx.messageType != 'icon-only')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["asahi-progress-bar", { 'max-w-360': _ctx.messageType !== 'long' && !_ctx.isSmallDevice}]),
          ref: "progressBar"
        }, [
          _withDirectives(_createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_ctx.progressBarMessage?.hasError)
                  ? (_openBlock(), _createBlock(_component_AllertCart, {
                      key: 0,
                      "height-value": 17,
                      "width-value": 14
                    }))
                  : _createCommentVNode("", true),
                (_ctx.progressBarMessage?.hasSucccess)
                  ? (_openBlock(), _createBlock(_component_SuccessCart, {
                      key: 1,
                      "height-value": 17,
                      "width-value": 14
                    }))
                  : _createCommentVNode("", true),
                (_ctx.messageType === 'header')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: _normalizeClass(["fw-normal", _ctx.isMsgColor]),
                      innerHTML: _ctx.progressBarMessage.title
                    }, null, 10, _hoisted_4))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_AsahiProgress, {
                "is-white": _ctx.isWhite,
                barHeight: "4",
                percentage: _ctx.getFillPercentage(),
                success: _ctx.progressBarMessage?.hasSucccess === true
              }, null, 8, ["is-white", "percentage", "success"]),
              _createElementVNode("div", {
                class: _normalizeClass(["options-container py-3", {'in-homepage' : _ctx.isHomePge}])
              }, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('Order capacity')), 1),
                _createElementVNode("div", {
                  class: "d-flex align-items-center gap-1 fw-bold options-container-message",
                  innerHTML: _ctx.progressBarMessage.subtitle
                }, null, 8, _hoisted_6),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('Weight')), 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.progressBar?.iTotalCartWeight) + " / " + _toDisplayString(_ctx.progressBar?.iMaximumOrderWeight) + " Kg ", 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('Number of pallets')), 1),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.totalCartPallet) + " / " + _toDisplayString(_ctx.progressBar?.iMaximumOrderPallet), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('Hectoliters')), 1),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.progressBar?.iTotalCartVoulume || 0), 1)
                ]),
                (_ctx.isFreeBeerCheckActive)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('PLN Products')), 1),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.progressBar?.iTotalFreeItems || 0), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ], 512), [
            [_vShow, _ctx.messageType === 'header']
          ]),
          (_ctx.messageType === 'long')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["asahi-progress-bar-message d-flex gap-1 align-items-start", _ctx.messageColorClass])
              }, [
                _createElementVNode("div", _hoisted_19, [
                  (_ctx.progressBarMessage?.hasError)
                    ? (_openBlock(), _createBlock(_component_AllertCart, {
                        key: 0,
                        "height-value": 24,
                        "width-value": 24
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.progressBarMessage?.hasSucccess)
                    ? (_openBlock(), _createBlock(_component_SuccessCart, {
                        key: 1,
                        "height-value": 24,
                        "width-value": 24
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["d-flex align-items-center gap-1 fw-normal", _ctx.isMsgColor]),
                    innerHTML: this.progressBarMessage.subtitle
                  }, null, 10, _hoisted_20),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createTextVNode(_toDisplayString(_ctx.$t('Weight')) + " ", 1),
                      _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.progressBar?.iTotalCartWeight) + " / " + _toDisplayString(_ctx.progressBar?.iMaximumOrderWeight) + " Kg", 1)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createTextVNode(_toDisplayString(_ctx.$t('Number of pallets')) + " ", 1),
                      _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.totalCartPallet) + " / " + _toDisplayString(_ctx.progressBar?.iMaximumOrderPallet), 1)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createTextVNode(_toDisplayString(_ctx.$t('Hectoliters')) + " ", 1),
                      _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.progressBar?.iTotalCartVoulume), 1)
                    ]),
                    (_ctx.isFreeBeerCheckActive)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createTextVNode(_toDisplayString(_ctx.$t('PLN Products')) + " ", 1),
                          _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.progressBar?.iTotalFreeItems), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.messageType === 'mobile-long')
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  (_ctx.progressBarMessage?.hasError)
                    ? (_openBlock(), _createBlock(_component_AllertCart, {
                        key: 0,
                        "height-value": 20,
                        "width-value": 20
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.progressBarMessage?.hasSucccess)
                    ? (_openBlock(), _createBlock(_component_SuccessCart, {
                        key: 1,
                        "height-value": 20,
                        "width-value": 20,
                        "is-white": true
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["col-12 asahi-compact-message", _ctx.isMsgColor]),
                      innerHTML: _ctx.progressBarMessage?.subtitle
                    }, null, 10, _hoisted_34)
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["col-12 asahi-compact-message", _ctx.isMsgColor]),
                      innerHTML: _ctx.progressBarMiniMessage?.title
                    }, null, 10, _hoisted_36)
                  ]),
                  _createVNode(_component_AsahiProgress, {
                    "is-white": _ctx.isWhite,
                    barHeight: "4",
                    percentage: _ctx.getFillPercentage(),
                    success: _ctx.progressBarMessage?.hasSucccess === true
                  }, null, 8, ["is-white", "percentage", "success"]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createTextVNode(_toDisplayString(_ctx.$t('Weight')) + " ", 1),
                      _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.progressBar?.iTotalCartWeight) + " / " + _toDisplayString(_ctx.progressBar?.iMaximumOrderWeight) + " Kg", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createTextVNode(_toDisplayString(_ctx.$t('Number of pallets')) + " ", 1),
                      _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.totalCartPallet) + " / " + _toDisplayString(_ctx.progressBar?.iMaximumOrderPallet), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createTextVNode(_toDisplayString(_ctx.$t('Hectoliters')) + " ", 1),
                      _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.progressBar?.iTotalCartVoulume || 0), 1)
                    ])
                  ]),
                  (_ctx.isFreeBeerCheckActive)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["col-12 d-flex justify-content-between", { "primary-light-green-text" : _ctx.productFreeBeer.length > 0, "gray" : _ctx.productFreeBeer.length === 0}])
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.$t('1 PLN')) + " ", 1),
                          _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.progressBar?.iTotalFreeItems || 0), 1)
                        ], 2)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.messageType === 'mobile')
      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                (_ctx.progressBarMessage?.hasError)
                  ? (_openBlock(), _createBlock(_component_AllertCart, {
                      key: 0,
                      "height-value": 17,
                      "width-value": 14
                    }))
                  : _createCommentVNode("", true),
                (_ctx.progressBarMessage?.hasSucccess)
                  ? (_openBlock(), _createBlock(_component_SuccessCart, {
                      key: 1,
                      "height-value": 17,
                      "width-value": 14,
                      "is-white": true
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "fw-normal mobile-title",
                  innerHTML: this.progressBarMiniMessage.title
                }, null, 8, _hoisted_52)
              ]),
              _createVNode(_component_AsahiProgress, {
                "is-white": _ctx.isWhite,
                barHeight: "4",
                percentage: _ctx.getFillPercentage(),
                success: _ctx.progressBarMessage?.hasSucccess === true
              }, null, 8, ["is-white", "percentage", "success"])
            ])
          ]),
          (_ctx.messageType === 'long')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["asahi-progress-bar-message d-flex gap-1 align-items-start", _ctx.messageColorClass])
              }, [
                _createElementVNode("div", _hoisted_53, [
                  (_ctx.progressBarMessage?.hasError)
                    ? (_openBlock(), _createBlock(_component_AllertCart, {
                        key: 0,
                        "height-value": 24,
                        "width-value": 24
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.progressBarMessage?.hasSucccess)
                    ? (_openBlock(), _createBlock(_component_SuccessCart, {
                        key: 1,
                        "height-value": 24,
                        "width-value": 24
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["d-flex align-items-center gap-1 fw-normal", _ctx.isMsgColor]),
                    innerHTML: this.progressBarMessage.subtitle
                  }, null, 10, _hoisted_54),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createTextVNode(_toDisplayString(_ctx.$t('Weight')) + " ", 1),
                      _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.progressBar?.iTotalCartWeight) + " / " + _toDisplayString(_ctx.progressBar?.iMaximumOrderWeight) + " Kg", 1)
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _createTextVNode(_toDisplayString(_ctx.$t('Number of pallets')) + " ", 1),
                      _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.totalCartPallet) + " / " + _toDisplayString(_ctx.progressBar?.iMaximumOrderPallet), 1)
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createTextVNode(_toDisplayString(_ctx.$t('Hectoliters')) + " ", 1),
                      _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.progressBar?.iTotalCartVoulume || 0), 1)
                    ]),
                    (_ctx.isFreeBeerCheckActive)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                          _createTextVNode(_toDisplayString(_ctx.$t('1 PLN')) + " ", 1),
                          _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.progressBar?.iTotalFreeItems || 0), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 2))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.messageType === 'compact')
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["asahi-compact-container fs-6", {
      'border-default-text': !_ctx.isMobile && !(_ctx.progressBarMessage?.hasError || _ctx.progressBarMessage?.hasSucccess),
      'border-error-text': !_ctx.isMobile && _ctx.progressBarMessage?.hasError,
      'border-success-text': !_ctx.isMobile && _ctx.progressBarMessage?.hasSucccess
     }])
        }, [
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", null, [
              (_ctx.progressBarMessage?.hasError)
                ? (_openBlock(), _createBlock(_component_AllertCart, {
                    key: 0,
                    "height-value": 17,
                    "width-value": 14
                  }))
                : _createCommentVNode("", true),
              (_ctx.progressBarMessage?.hasSucccess)
                ? (_openBlock(), _createBlock(_component_SuccessCart, {
                    key: 1,
                    "height-value": 17,
                    "width-value": 14
                  }))
                : _createCommentVNode("", true)
            ]),
            (_ctx.messageType === 'compact')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["asahi-compact-message", _ctx.isMsgColor]),
                  innerHTML: this.progressBarMessage.title
                }, null, 10, _hoisted_65))
              : _createCommentVNode("", true)
          ]),
          (_ctx.messageType === 'compact' && _ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["asahi-compact-message", _ctx.isMsgColor]),
                innerHTML: this.progressBarMessage.mobileTitle
              }, null, 10, _hoisted_66))
            : _createCommentVNode("", true),
          _createVNode(_component_AsahiProgress, {
            "is-white": _ctx.isWhite,
            barHeight: "4",
            percentage: _ctx.getFillPercentage(),
            error: _ctx.progressBarMessage?.hasError === true && !_ctx.isMobile,
            success: _ctx.progressBarMessage?.hasSucccess === true && !_ctx.isMobile
          }, null, 8, ["is-white", "percentage", "error", "success"]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              (_ctx.isCompactAndFullTruck)
                ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                    _createTextVNode(_toDisplayString(_ctx.$t('Weight')) + " ", 1),
                    _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.progressBar?.iTotalCartWeight) + " / " + _toDisplayString(_ctx.progressBar?.iMaximumOrderWeight) + " Kg ", 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_71, [
                _createTextVNode(_toDisplayString(_ctx.$t('Number of pallets')) + " ", 1),
                _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.progressBar?.iTotalCartPalletQty) + " / " + _toDisplayString(_ctx.progressBar?.iMaximumOrderPallet), 1)
              ]),
              _createElementVNode("div", _hoisted_73, [
                _createTextVNode(_toDisplayString(_ctx.$t('Hectoliters')) + " ", 1),
                _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.progressBar?.iTotalCartVoulume || 0), 1)
              ]),
              (_ctx.isFreeBeerCheckActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                    _createTextVNode(_toDisplayString(_ctx.$t('1 PLN')) + " ", 1),
                    _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.progressBar?.iTotalFreeItems || 0), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.messageType === 'mini')
      ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("div", _hoisted_79, [
              _createElementVNode("div", null, [
                (_ctx.progressBarMiniMessage?.hasError)
                  ? (_openBlock(), _createBlock(_component_AllertCart, {
                      key: 0,
                      "height-value": 17,
                      "width-value": 14
                    }))
                  : _createCommentVNode("", true),
                (_ctx.progressBarMiniMessage?.hasSucccess)
                  ? (_openBlock(), _createBlock(_component_SuccessCart, {
                      key: 1,
                      "height-value": 17,
                      "width-value": 14
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["asahi-compact-message", _ctx.isMsgColor]),
                innerHTML: this.progressBarMiniMessage.title
              }, null, 10, _hoisted_80)
            ]),
            _createVNode(_component_AsahiProgress, {
              "is-white": _ctx.isWhite,
              barHeight: "4",
              percentage: _ctx.getFillPercentage()
            }, null, 8, ["is-white", "percentage"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.progressBarMessage?.hasError && _ctx.messageType === "icon-only")
      ? (_openBlock(), _createBlock(_component_AllertCart, {
          key: 4,
          "height-value": 17,
          style: {"padding-bottom":"5px"},
          "width-value": 14
        }))
      : _createCommentVNode("", true),
    (_ctx.progressBarMessage?.hasSucccess && _ctx.messageType === "icon-only")
      ? (_openBlock(), _createBlock(_component_SuccessCart, {
          key: 5,
          "height-value": 17,
          "width-value": 14,
          style: {"padding-bottom":"5px"},
          "is-white": true
        }))
      : _createCommentVNode("", true)
  ], 64))
}